<template>
        <q-btn
            v-bind="$attrs"
            :color="color"
            :text-color="textcolor"
            :label="label"
            :dense="dense"
            :no-caps="nocaps"
            :size="size"
            @click="$emit('click', $event)"
            :data-component-name="$options.name"
        />
</template>

<script>
    import Qbtn from 'quasar'

    export default {
        name: 'Button',
        extends: Qbtn,
        props: {
            color: {
                type: String,
                default: "primary"
            },
            textcolor: {
                type: String,
                default: null
            },
            label: {
                type: String,
                default: null
            },
            dense: {
                type: Boolean,
                default: false
            },
            nocaps: {
                type: Boolean,
                default: true
            },
            size: {
                type: String,
                default: null // 'xs', 'sm', 'md', 'lg', 'xl' 
            },
        }
    }
</script>